export const getQaChunksUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/qa_chunks`;

export const getQaChunkUrl = (locationId: string, agentId: string, id: string) =>
  `/business/locations/${locationId}/agents/${agentId}/qa_chunks/${id}`;

export const getQaChunkImportUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/qa_chunks/import`;
